import React from "react";
import { Space, Typography } from "antd";
const { Text } = Typography;

interface HeadingAndTextProps {
    heading?: string;
    text?: string;
}

const HeadingAndText: React.FC<HeadingAndTextProps> = ({ heading, text }) => {
    return (
        <Space direction="vertical" size={[0, 0]}>
            {heading && <Text strong>{heading}</Text>}
            {text && <Text>{text}</Text>}
        </Space>
    );
};

export default HeadingAndText;